<div class="wt-input-radio"
     [class.wt-input-radio--html]="isHTML"
     [class.wt-input-radio--disabled]="disabled">
  <input type="radio"
         class="wt-input-radio__input"
         [id]="id"
         [name]="groupName"
         [value]="value"
         [disabled]="disabled"
         [attr.aria-label]="ariaLabel ? ariaLabel : null"
         [checked]="isChecked"
         [(ngModel)]="modelValue">
  <label class="wt-input-radio__label" [for]="id">
    <ng-content></ng-content>
  </label>
</div>
